import { Add, AddText, AddTextLabel } from "./core";
const Globals = require("./globals");

const ConfigurePanZoom = () => {
  const canvas = Globals.canvas;

  const context = canvas.getContext("2d");
  context.clearRect(0, 0, canvas.width, canvas.height);

  // const z = drawGrid(canvas);

  canvas.on(
    "mouse:wheel",
    function (opt) {
      var delta = opt.e.deltaY * 0.7;
      var zoom = canvas.getZoom();
      zoom *= 0.98888 ** delta;

      if (zoom > 3) zoom = 3;
      if (zoom < 0.08) zoom = 0.08;

      canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);

      // d3.select("#svgbg").transition().call(z.scaleBy, 0.9888);

      Globals.zoom = {
        point: { x: opt.e.offsetX, y: opt.e.offsetY },
        zoom: zoom,
      };

      opt.e.preventDefault();
      opt.e.stopPropagation();
    },
    { passive: true }
  );

  canvas.on("mouse:down", function (opt) {
    var evt = opt.e;

    Globals.mouseDown = true;

    if (evt.button === 1 || (evt.altKey === true && evt.button === 0)) {
      this.isDragging = true;
      this.selection = false;
      this.lastPosX = evt.clientX;
      this.lastPosY = evt.clientY;
    }
  });

  canvas.on("mouse:move", function (opt) {
    var e = opt.e;

    // Globals.awareness.setLocalStateField("cursor", {
    //   x: e.clientX,
    //   y: e.clientY,
    // });

    if (this.isDragging) {
      var vpt = this.viewportTransform;
      vpt[4] += e.clientX - this.lastPosX;
      vpt[5] += e.clientY - this.lastPosY;
      this.requestRenderAll();
      this.lastPosX = e.clientX;
      this.lastPosY = e.clientY;
    }

    // Fix for floating edit box when dragging
    // could possibly be accomplished with _mouseDownHandler()
    if (Globals.mouseDown) {
      const obj = canvas.getActiveObject();

      if (!obj || obj.type !== "StickyEdit") return;
      obj.exitEditing();
    }
  });

  canvas.on("mouse:up", function (opt) {
    var evt = opt.e;

    Globals.mouseDown = false;

    const create = Globals.create;
    const createType = Globals.createType;

    if (create) {
      var pointer = canvas.getPointer(evt.e);

      switch (createType) {
        case 0:
          Add(pointer.x, pointer.y);
          break;
        case 1:
          Add(pointer.x, pointer.y, 400);
          break;
        case 2:
          AddTextLabel(pointer.x, pointer.y);
          break;
        case 3:
          AddText(pointer.x, pointer.y);
          break;
      }

      Globals.create = false;
      canvas.defaultCursor = "default";
    }

    // on mouse up we want to recalculate new interaction
    // for all objects, so we call setViewportTransform
    this.setViewportTransform(this.viewportTransform);
    this.isDragging = false;
    this.selection = true;
  });
};

const setZoomTo = (zoom) => {
  Globals.canvas.zoomToPoint(zoom.point, zoom.zoom);
  Globals.canvas.setViewportTransform(Globals.canvas.viewportTransform);
};

const drawGrid = (cnv) => {
  const width = cnv.width;
  const height = cnv.height;

  // Prepare the SVG.
  const svg = d3
    .select("#svgbg")
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", [0, 0, width, height]);

  // Select the grid, inner grid and canvas (so we can use them when we pan and zoom).
  const patternGrid = svg.select("#grid");
  const patternInnerGrid = svg.select("#inner-grid");
  const canvas = svg.select("g");

  // The main 'magic' happenes in our zoom callback method.
  const zoomed = (transform) => {
    const transform10 = parseInt(transform.k * 10);
    const transform100 = transform10 * 10;

    // Don't move the grid itself, simply change the pattern.
    patternGrid
      .attr("x", parseInt(transform.x % transform100))
      .attr("y", parseInt(transform.y % transform100))
      .attr("width", transform100)
      .attr("height", transform100);
    patternInnerGrid.attr("width", transform10).attr("height", transform10);

    // Translate and scale the canvas.
    canvas.attr("transform", transform);
  };

  const zoom = d3
    .zoom()
    .extent([
      [0, 0],
      [width, height],
    ])
    .on("zoom", () => zoomed(d3.event.transform));

  // svg.call(zoom);

  return zoom;
};

export default ConfigurePanZoom;
export { setZoomTo };
